<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol lg="4">
                <!-- <p class="decode-result">
                  Last result: <b>{{ result }}</b>
                </p> -->
                <template style="width: 500px; height: 500px">
                  <qrcode-stream
                    :camera="camera"
                    @decode="onDecode"
                    @init="onInit"
                  >
                    <div v-if="validationSuccess" class="validation-success">
                      Your code is accepted
                    </div>

                    <div v-if="validationFailure" class="validation-failure">
                      Your code is not valid
                    </div>

                    <div v-if="validationPending" class="validation-pending">
                      Please wait...
                    </div>
                  </qrcode-stream>
                </template>
              </CCol>
              <CCol lg="4" v-if="validationSuccess">
                <table class="table" v-for="(value, key) in data" v-bind:key="uniqueId(key)">
                    <thead>
                      <tr>
                        <th colspan="4">Seller: {{key}}</th>
                      </tr>
                      <tr>
                        <th scope="col">Product Name</th>
                        <th scope="col">Qty</th>
                        <th scope="col">Price</th>
                        <th scope="col">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="d in data[key]" v-bind:key="d.id">
                        <td>{{ d.product_name }}</td>
                        <td>{{ d.qty }}</td>
                        <td>{{ d.price }}</td>
                        <td>{{ d.product_name }}</td>
                      </tr>
                    </tbody>
                </table>

                <CButton @click="processClaim" color="success">
                  <i class="fa fa-save"></i>
                  Process Claim
                </CButton>

                <!-- <ul>
                  <li v-for="d in data" v-bind:key="d.id">{{d.product_name}} - Rp. {{d.price}}</li>
                </ul> -->
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";
import _ from "lodash";

export default {
  name: "VoucherClaim",
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
  },
  data() {
    return {
      data: [],
      isValid: undefined,
      camera: "auto",
      result: null,
    };
  },

  computed: {
    validationPending() {
      return this.isValid === undefined && this.camera === "off";
    },

    validationSuccess() {
      return this.isValid === true;
    },

    validationFailure() {
      return this.isValid === false;
    },
  },

  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    onInit(promise) {
      promise.catch(console.error).then(this.resetValidationState);
      //this.byPass("VUMyMDA2MDIwMDAxI1ZRMjIwODI5MDAwMDE");
    },

    resetValidationState() {
      this.isValid = undefined;
    },

    async onDecode(content) {
      this.result = content;
      this.turnCameraOff();

      // pretend it's taking really long
      await this.timeout(3000);

      this.axios
        .post("/console/voucher/qr-claim", { qr_code: content })
        .then((response) => {
          if (response.data.status === 2000) {
            //await this.timeout(2000);
            this.data = response.data.data;
            this.isValid = true;
          } else {
            this.isValid = false;
            this.turnCameraOn();
          }
        });

      //this.isValid = content.startsWith("http");

      // some more delay, so users have time to read the message
      // await this.timeout(2000);

      // this.turnCameraOn();
    },

    byPass(content) {
      this.axios
        .post("/console/voucher/qr-claim", { qr_code: content })
        .then((response) => {
          if (response.data.status === 2000) {
            //await this.timeout(2000);
            this.data = response.data.data;
            this.isValid = true;
          } else {
            this.isValid = false;
            this.turnCameraOn();
          }
        });
    },

    turnCameraOn() {
      this.camera = "auto";
    },

    turnCameraOff() {
      this.camera = "off";
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },

    processClaim() {
      event.preventDefault();
      if (confirm("Are you sure want to process this claim ?")) {
      //this.result
      this.axios
        .post("/console/voucher/process-qr-claim", { qr_code: this.result })
        .then((response) => {
          if (response.data.status === 2000) {
            //await this.timeout(2000);
            this.data = response.data.data;
            this.isValid = true;
          } else {
            this.isValid = false;
            this.turnCameraOn();
          }
        });
      } else {
        alert("Please check QR again");
        location.reload();
      }
      
    },
    
  },
};
</script>

<style scoped>
.validation-success,
.validation-failure,
.validation-pending {
  position: relative;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.validation-success {
  color: green;
}
.validation-failure {
  color: red;
}
</style>